import { Controller } from "@hotwired/stimulus";
import { AsYouType, parsePhoneNumberFromString } from "libphonenumber-js";

export default class extends Controller {
  static targets = ["phoneInput", "statusIndicator"];
  static values = { phone: String };

  phoneInputTargetConnected(element) {
    this.formatPhoneNumber({ target: element });
    this.validatePhone({ target: element }); // Validate on initialization
  }

  formatPhoneNumber(event) {
    const input = event.target;
    const cursorPosition = input.selectionStart;
    const digits = input.value.replace(/\D/g, "");
    const oldDigitCount = input.value.slice(0, cursorPosition).replace(/\D/g, "").length;

    if (!digits) {
      input.value = "";
      return;
    }

    // For complete numbers (10 digits), use national format to avoid country code
    const phoneNumber = parsePhoneNumberFromString(digits, "US");
    if (phoneNumber?.isValid()) {
      input.value = phoneNumber.formatNational();
      return;
    }

    // For partial numbers, use as-you-type formatting
    const formatter = new AsYouType("US");
    const formatted = formatter.input(digits);
    // Remove country code if present (e.g., "1 (707) 123-4567" -> "(707) 123-4567")
    input.value = formatted.replace(/^1\s/, "");

    // Restore cursor position
    let newPosition = 0;
    let digitsSeen = 0;
    for (const char of input.value) {
      if (digitsSeen >= oldDigitCount) break;
      if (/\d/.test(char)) digitsSeen++;
      newPosition++;
    }
    input.setSelectionRange(newPosition, newPosition);
  }

  isValid(input) {
    const digits = input.value.replace(/\D/g, "");
    try {
      const phoneNumber = parsePhoneNumberFromString(digits, "US");
      return phoneNumber?.isValid() || false;
    } catch {
      return false;
    }
  }

  validatePhone(event) {
    const input = event.target;
    const isValid = this.isValid(input);
    this.updateStatusIndicator(isValid, input.value.length > 0);
    return isValid;
  }

  updateStatusIndicator(isValid, hasContent) {
    if (!this.hasStatusIndicatorTarget) return;

    const indicator = this.statusIndicatorTarget;
    const placeholder = indicator.querySelector('.status-placeholder');

    // Clear existing content
    placeholder.innerHTML = '';
    indicator.className = 'phone-status-indicator ms-2';

    // Only show status for invalid numbers with content
    if (!hasContent || isValid) return;

    indicator.classList.add('text-danger');
    placeholder.innerHTML = 'Not a valid phone number';
  }
}
